import {
  DELETE_NON_WORKING_HOURS,
  DELETE_NON_WORKING_HOURS_SUCCESS,
  GET_ALL_NON_WORKING_HOURS,
  GET_ALL_NON_WORKING_HOURS_ERROR,
  GET_ALL_NON_WORKING_HOURS_SUCCESS,
} from "./actionType"

const initialState = {}

const calculateincentive = (state = initialState, action) => {
  switch (action.type) {
    // start scrutiny type
    case GET_ALL_NON_WORKING_HOURS:
      state = {
        ...state,
        getallnonworkinghoursSuccess: action.payload,
        getallnonworkinghoursError: null,
      }
      break

    case GET_ALL_NON_WORKING_HOURS_SUCCESS:
      state = {
        ...state,
        getallnonworkinghoursSuccess: action.payload,
        getallnonworkinghoursError: null,
      }
      break

    case GET_ALL_NON_WORKING_HOURS_ERROR:
      state = { ...state, getallnonworkinghoursError: action.payload }
      break
    // end scrutiny type
    case DELETE_NON_WORKING_HOURS:
      return {
        ...state,
        deletenonworkinghoursSuccess: action.payload,
      }
      break
    case DELETE_NON_WORKING_HOURS_SUCCESS:
      return {
        ...state,
        deletenonworkinghoursSuccess: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default calculateincentive
